/* eslint-disable import/prefer-default-export */
import { useGetAllShipments } from "api/queries/shipments/useGetAllShipments";
import { useGetSettings } from "api/queries/user/useGetSettings";
// import { useGetAllQuotes } from "api/queries/quotes/useGetAllQuotes";
import useToken from "./useToken";
import usePermissions from "./usePermissions";

export function useGlobalData() {
  const { token } = useToken();
  const { permissions } = usePermissions();
  const permissionData: any = JSON.parse(permissions || "{}");
  useGetAllShipments({ enabled: !!token && !!permissionData?.permissions?.tracking?.view_shipments });
  useGetSettings({ enabled: !!token });
  // useGetAllQuotes({ enabled: !!token && !!permissionData?.permissions?.quoting?.view_quote_requests });
}
